// // ================================
// // Mega Menu Logic
// // ================================
// // Menu Selection
// document.addEventListener("DOMContentLoaded", function () {
//   const currentPage = window.location.pathname;
//   const menuItems = document.querySelectorAll(".cl-header--nav-bar-item-link");
//   menuItems.forEach((item) => {
//       if (item.getAttribute("href") === currentPage) {
//           item.classList.add("current-page");
//       } else {
//           item.classList.remove("current-page");
//       }
//   });
// });
// //Menu Logic 
// function hideAllMenus() {
//   const overlay = document.querySelector(".cl-mega-menu-overlay");
//   if (!overlay) return;

//   overlay.classList.remove("active");
//   overlay.style.maxHeight = "0";

//   document.querySelectorAll(".has-dropdown").forEach((item) => {
//       item.classList.remove("active");
//   });

//   document.querySelectorAll(".cl-header--mega-menu-wrapper").forEach((menu) => {
//       menu.classList.remove("active");
//       menu.style.maxHeight = "0";
//   });

//   document
//       .querySelectorAll(
//           ".cl-header--mega-menu-wrapper--content, .cl-header--mega-menu-items-btm-wrapper--content"
//       )
//       .forEach((content) => {
//           content.style.opacity = "0";
//       });

//   const globalOverlay = document.getElementById("cl-global-overlay");
//   if (globalOverlay) {
//       globalOverlay.classList.remove("active");
//   }
// }

// document.addEventListener("DOMContentLoaded", function () {
//   document.body.classList.add("js-loaded");

//   const menuItems = document.querySelectorAll(".has-dropdown");
//   const overlay = document.querySelector(".cl-mega-menu-overlay");
//   let currentMenu = null;
//   let isHovering = false;

//   hideAllMenus();
//   function showMenu(item) {
//       const megaMenu = item.querySelector(".cl-header--mega-menu-wrapper")
//       const content = item.querySelector(".cl-header--mega-menu-wrapper--content")
//       const btmWrappers = item.querySelectorAll(".cl-header--mega-menu-items-btm-wrapper, .cl-header--mega-menu-items-btm-wrapper--content")
//       const header = document.querySelector(".cl-sticky-header")
//       if (!megaMenu || !content || !overlay) return
//       const headerHeight = header ? header.offsetHeight : 0
//       const maxAvailableHeight = window.innerHeight - headerHeight
//       megaMenu.classList.add("active")
//       content.style.opacity = "1"
//       btmWrappers.forEach(el => setTimeout(() => el.style.opacity = "1", 500))
//       item.classList.add("active")
//       const contentHeight = megaMenu.scrollHeight
//       const finalHeight = Math.min(contentHeight, maxAvailableHeight)
//       overlay.classList.add("active")
//       overlay.style.maxHeight = finalHeight + "px"
//       megaMenu.style.maxHeight = finalHeight + "px"
//       currentMenu = item
//       const globalOverlay = document.getElementById("cl-global-overlay")
//       if (globalOverlay) globalOverlay.classList.add("active")
//   }

//   // === New: Hide menu and remove overlay ===
//   function hideMenu() {
//       if (currentMenu) {
//           const megaMenu = currentMenu.querySelector(".cl-header--mega-menu-wrapper");
//           const content = currentMenu.querySelector(".cl-header--mega-menu-wrapper--content");
//           const btmWrapper = currentMenu.querySelector(".cl-header--mega-menu-items-btm-wrapper--content");

//           currentMenu.classList.remove("active");
//           if (megaMenu) megaMenu.classList.remove("active");
//           if (content) content.style.opacity = "0";
//           if (btmWrapper) btmWrapper.style.opacity = "0";
//       }

//       overlay.classList.remove("active");

//       // Remove global dim overlay
//       const globalOverlay = document.getElementById("cl-global-overlay");
//       if (globalOverlay) {
//           globalOverlay.classList.remove("active");
//       }

//       currentMenu = null;
//   }

//   function isInsideMenuArea(target, item, megaMenu) {
//       return (
//           item.contains(target) ||
//           megaMenu?.contains(target) ||
//           overlay.contains(target)
//       );
//   }

//   menuItems.forEach((item) => {
//       const megaMenu = item.querySelector(".cl-header--mega-menu-wrapper");

//       item.addEventListener("mouseenter", () => {
//           isHovering = true;
//           if (currentMenu && currentMenu !== item) {
//               hideAllMenus();
//           }
//           showMenu(item);
//       });

//       item.addEventListener("mouseleave", (e) => {
//           const related = e.relatedTarget;
//           if (!isInsideMenuArea(related, item, megaMenu)) {
//               isHovering = false;
//               hideAllMenus();
//           }
//       });

//       megaMenu?.addEventListener("mouseenter", () => {
//           isHovering = true;
//       });

//       megaMenu?.addEventListener("mouseleave", (e) => {
//           const related = e.relatedTarget;
//           if (!isInsideMenuArea(related, item, megaMenu)) {
//               isHovering = false;
//               hideAllMenus();
//           }
//       });
//   });

//   overlay?.addEventListener("mouseleave", (e) => {
//       const related = e.relatedTarget;

//       const anyHovered = Array.from(
//           document.querySelectorAll(".has-dropdown")
//       ).some((item) => {
//           const menu = item.querySelector(".cl-header--mega-menu-wrapper");
//           return item.contains(related) || menu?.contains(related);
//       });

//       if (!anyHovered) {
//           isHovering = false;
//           hideAllMenus();
//       }
//   });

//   window.addEventListener("scroll", () => {
//       if (!isHovering) {
//           hideAllMenus();
//       }
//   });
// });

// // ================================
// // Cart Count
// // ================================
// function updateCartCountBubble() {
//   fetch("/cart.js")
//       .then((res) => res.json())
//       .then((data) => {
//           const count = data.item_count;

//           document.querySelectorAll(".cart-count-bubble span").forEach((span) => {
//               span.innerText = count;
//               span.parentElement.style.display = count === 0 ? "none" : "flex";
//           });

//           document.querySelectorAll(".cart-count").forEach((span) => {
//               span.innerText = count;
//               span.style.display = count === 0 ? "none" : "inline-block";
//           });

//           document.querySelectorAll(".red-dot").forEach((dot) => {
//               dot.style.display = count === 0 ? "none" : "block";
//           });

//           const stickyBtn = document.querySelector(
//               'product-info .stickyAddToCart button[type="submit"]'
//           );
//           if (stickyBtn) {
//               stickyBtn.style.backgroundColor = count === 0 ? "#707070" : "#ce0a2c";
//           }
//       });
// }
// window.addEventListener("DOMContentLoaded", updateCartCountBubble);
// // ================================
// // CL Sticky Header Logic
// // ================================
// document.addEventListener("DOMContentLoaded", function () {
// //   const header = document.querySelector(".clStickyHeader");
//   const header = document.querySelector(".new-header");
//   const stickyATC = document.querySelector(".stickyAddToCart");
//   const stickyFilter = document.querySelector("aside#main-collection-filters");
//   const stickyDate = document.querySelector(".clDates");
//   if (!header) return;
//   let lastScroll = window.scrollY;
//   const threshold = 100;
//   let isSticky = false;
//   function isDropdownActive() {
//       return document.querySelector(
//           ".cl-header--nav-bar-items.has-dropdown.active"
//       );
//   }
//   function updateStickyATCPosition() {
//       if (!stickyATC && !stickyFilter && !stickyDate) return;
//       const stickyTopValue = "80px";
//       const isSticky = header.classList.contains("is-sticky");
//       const newTop = isSticky ? stickyTopValue : "";
//       if (stickyATC) stickyATC.style.top = newTop;
//       if (stickyFilter) stickyFilter.style.top = newTop;
//       if (stickyDate) stickyDate.style.top = newTop;
//       const isStickyATCActive = stickyATC?.classList.contains("active");
//       const isStickyFilterLifted = stickyFilter?.style.top === stickyTopValue;
//       const isStickyDateLifted = stickyDate?.style.top === stickyTopValue;
//       if (isStickyATCActive || isStickyFilterLifted || isStickyDateLifted) {
//           header.style.boxShadow = "none";
//       } else {
//           header.style.boxShadow = "";
//       }
//   }
//   function setStickyState(active) {
//       if (active === isSticky) return;
//       isSticky = active;
//       if (isSticky) {
//           header.classList.add("is-sticky");
//           document
//               .querySelectorAll(".hide-on-sticky")
//               .forEach((el) => el.classList.add("hidden"));
//           document
//               .querySelectorAll(".show-on-sticky")
//               .forEach((el) => el.classList.remove("hidden"));
//       } else {
//           header.classList.remove("is-sticky");
//           document
//               .querySelectorAll(".hide-on-sticky")
//               .forEach((el) => el.classList.remove("hidden"));
//           document
//               .querySelectorAll(".show-on-sticky")
//               .forEach((el) => el.classList.add("hidden"));
//       }
//       updateStickyATCPosition();
//   }
//   function handleScroll() {
//       const currentScroll = window.scrollY;
//       if (window.innerWidth <= 768) {
//           setStickyState(false);
//           header.style.transform = "";
//           return;
//       }
//       const dropdownActive = isDropdownActive();
//       // Reset at top
//       if (currentScroll === 0) {
//           setStickyState(false);
//           header.style.transform = "";
//       } else if (dropdownActive) {
//           // Megamenu is open - header must be sticky, use transform for show/hide
//           setStickyState(true);

//           if (currentScroll > lastScroll) {
//               // Scrolling down when megamenu open - show header
//               header.style.transform = "translateY(0)";
//           } else if (currentScroll < lastScroll) {
//               // Scrolling up when megamenu open - hide header to show megamenu clearly
//               header.style.transform = "translateY(-100%)";
//           }
//       } else {
//           // Megamenu is NOT open - manage is-sticky class normally
//           if (currentScroll > lastScroll) {
//               // Scrolling down - remove sticky class
//               setStickyState(false);
//               header.style.transform = "";
//           } else if (currentScroll < lastScroll) {
//               // Scrolling up - add sticky class (normal sticky header)
//               setStickyState(true);
//               header.style.transform = "";
//           }
//       }
//       lastScroll = Math.max(0, currentScroll);
//   }
//   window.addEventListener("scroll", handleScroll);
//   window.addEventListener("resize", handleScroll);
//   const dropdownObserver = new MutationObserver(handleScroll);
//   document
//       .querySelectorAll(".cl-header--nav-bar-items.has-dropdown")
//       .forEach((el) =>
//           dropdownObserver.observe(el, {
//               attributes: true,
//               attributeFilter: ["class"],
//           })
//       );
//   // Observe changes in stickyAddToCart active class
//   if (stickyATC) {
//       const atcObserver = new MutationObserver(updateStickyATCPosition);
//       atcObserver.observe(stickyATC, {
//           attributes: true,
//           attributeFilter: ["class"],
//       });
//   }
// });
// // // ================================
// // // Mobile Sticky Header
// // // ================================
// document.addEventListener("DOMContentLoaded", function () {
//   const header = document.querySelector(".cl-header--main-wrapper");
//   let lastScrollY = window.scrollY;

//   if (window.innerWidth <= 767 && header) {
//       window.addEventListener("scroll", function () {
//           const scrollY = window.scrollY;
//           if (scrollY > 100) {
//               header.classList.add("mb-sticky-header");

//               if (scrollY < lastScrollY) {
//                   // Scrolling up
//                   header.classList.add("show");
//                   header.classList.remove("hide");
//               } else {
//                   // Scrolling down
//                   header.classList.add("hide");
//                   header.classList.remove("show");
//               }
//           } else {
//               // Reset everything near top
//               header.classList.remove("mb-sticky-header", "show", "hide");
//           }
//           lastScrollY = scrollY;
//       });
//   }
// });
// const megaMenuWrapperContents = document.querySelectorAll('.cl-header--mega-menu-wrapper--content');
// megaMenuWrapperContents.forEach((megaMenuWrapperContent, index) => {
//   const megaMenuItemsBtmWrapper = megaMenuWrapperContent.querySelector('.cl-header--mega-menu-items-btm-wrapper');

//   if (megaMenuItemsBtmWrapper) {
//       megaMenuWrapperContent.style.padding = '0';
//   } else {
//       megaMenuWrapperContent.style.padding = '0 0 50px';
//   }
// });

// document.addEventListener("DOMContentLoaded", function () {
//   const header = document.querySelector(".new-header");
//   const filters = document.querySelector("#main-collection-filters");

//   if (!header || !filters) return;

//   function updateFiltersPosition() {
//     if (
//       header.classList.contains("is-plain") &&
//       header.classList.contains("is-visible")
//     ) {
//       filters.style.top = "78px";
//     } else {
//       filters.style.top = "";
//     }
//   }

//   // Run on load
//   updateFiltersPosition();

//   // Optional: observe class changes on header
//   const observer = new MutationObserver(updateFiltersPosition);
//   observer.observe(header, { attributes: true, attributeFilter: ["class"] });
// });
// ================================
// Mega Menu Logic
// ================================
// Menu Selection
document.addEventListener("DOMContentLoaded", function () {
    const currentPage = window.location.pathname;
    const menuItems = document.querySelectorAll(".cl-header--nav-bar-item-link");
    menuItems.forEach((item) => {
        if (item.getAttribute("href") === currentPage) {
            item.classList.add("current-page");
        } else {
            item.classList.remove("current-page");
        }
    });
  });
  //Menu Logic 
  function hideAllMenus() {
    const overlay = document.querySelector(".cl-mega-menu-overlay");
    if (!overlay) return;
  
    overlay.classList.remove("active");
    overlay.style.maxHeight = "0";
  
    document.querySelectorAll(".has-dropdown").forEach((item) => {
        item.classList.remove("active");
    });
  
    document.querySelectorAll(".cl-header--mega-menu-wrapper").forEach((menu) => {
        menu.classList.remove("active");
        menu.style.maxHeight = "0";
    });
  
    document
        .querySelectorAll(
            ".cl-header--mega-menu-wrapper--content, .cl-header--mega-menu-items-btm-wrapper--content"
        )
        .forEach((content) => {
            content.style.opacity = "0";
        });
  
    const globalOverlay = document.getElementById("cl-global-overlay");
    if (globalOverlay) {
        globalOverlay.classList.remove("active");
    }
  }
  
  document.addEventListener("DOMContentLoaded", function () {
    document.body.classList.add("js-loaded");
  
    const menuItems = document.querySelectorAll(".has-dropdown");
    const overlay = document.querySelector(".cl-mega-menu-overlay");
    let currentMenu = null;
    let isHovering = false;
  
    hideAllMenus();
    function showMenu(item) {
        const megaMenu = item.querySelector(".cl-header--mega-menu-wrapper")
        const content = item.querySelector(".cl-header--mega-menu-wrapper--content")
        const btmWrappers = item.querySelectorAll(".cl-header--mega-menu-items-btm-wrapper, .cl-header--mega-menu-items-btm-wrapper--content")
        const header = document.querySelector(".cl-sticky-header")
        if (!megaMenu || !content || !overlay) return
        const headerHeight = header ? header.offsetHeight : 0
        const maxAvailableHeight = window.innerHeight - headerHeight
        megaMenu.classList.add("active")
        content.style.opacity = "1"
        btmWrappers.forEach(el => setTimeout(() => el.style.opacity = "1", 500))
        item.classList.add("active")
        const contentHeight = megaMenu.scrollHeight
        const finalHeight = Math.min(contentHeight, maxAvailableHeight)
        overlay.classList.add("active")
        overlay.style.maxHeight = finalHeight + "px"
        megaMenu.style.maxHeight = finalHeight + "px"
        currentMenu = item
        const globalOverlay = document.getElementById("cl-global-overlay")
        if (globalOverlay) globalOverlay.classList.add("active")
    }
  
    // === New: Hide menu and remove overlay ===
    function hideMenu() {
        if (currentMenu) {
            const megaMenu = currentMenu.querySelector(".cl-header--mega-menu-wrapper");
            const content = currentMenu.querySelector(".cl-header--mega-menu-wrapper--content");
            const btmWrapper = currentMenu.querySelector(".cl-header--mega-menu-items-btm-wrapper--content");
  
            currentMenu.classList.remove("active");
            if (megaMenu) megaMenu.classList.remove("active");
            if (content) content.style.opacity = "0";
            if (btmWrapper) btmWrapper.style.opacity = "0";
        }
  
        overlay.classList.remove("active");
  
        // Remove global dim overlay
        const globalOverlay = document.getElementById("cl-global-overlay");
        if (globalOverlay) {
            globalOverlay.classList.remove("active");
        }
  
        currentMenu = null;
    }
  
    function isInsideMenuArea(target, item, megaMenu) {
        return (
            item.contains(target) ||
            megaMenu?.contains(target) ||
            overlay.contains(target)
        );
    }
  
    menuItems.forEach((item) => {
        const megaMenu = item.querySelector(".cl-header--mega-menu-wrapper");
  
        item.addEventListener("mouseenter", () => {
            isHovering = true;
            if (currentMenu && currentMenu !== item) {
                hideAllMenus();
            }
            showMenu(item);
        });
  
        item.addEventListener("mouseleave", (e) => {
            const related = e.relatedTarget;
            if (!isInsideMenuArea(related, item, megaMenu)) {
                isHovering = false;
                hideAllMenus();
            }
        });
  
        megaMenu?.addEventListener("mouseenter", () => {
            isHovering = true;
        });
  
        megaMenu?.addEventListener("mouseleave", (e) => {
            const related = e.relatedTarget;
            if (!isInsideMenuArea(related, item, megaMenu)) {
                isHovering = false;
                hideAllMenus();
            }
        });
    });
  
    overlay?.addEventListener("mouseleave", (e) => {
        const related = e.relatedTarget;
  
        const anyHovered = Array.from(
            document.querySelectorAll(".has-dropdown")
        ).some((item) => {
            const menu = item.querySelector(".cl-header--mega-menu-wrapper");
            return item.contains(related) || menu?.contains(related);
        });
  
        if (!anyHovered) {
            isHovering = false;
            hideAllMenus();
        }
    });
  
    window.addEventListener("scroll", () => {
        if (!isHovering) {
            hideAllMenus();
        }
    });
  });
  
  // ================================
  // Cart Count
  // ================================
  function updateCartCountBubble() {
    fetch("/cart.js")
        .then((res) => res.json())
        .then((data) => {
            const count = data.item_count;
  
            document.querySelectorAll(".cart-count-bubble span").forEach((span) => {
                span.innerText = count;
                span.parentElement.style.display = count === 0 ? "none" : "flex";
            });
  
            document.querySelectorAll(".cart-count").forEach((span) => {
                span.innerText = count;
                span.style.display = count === 0 ? "none" : "inline-block";
            });
  
            document.querySelectorAll(".red-dot").forEach((dot) => {
                dot.style.display = count === 0 ? "none" : "flex";
            });
  
            const stickyBtn = document.querySelector(
                'product-info .stickyAddToCart button[type="submit"]'
            );
            if (stickyBtn) {
                stickyBtn.style.backgroundColor = count === 0 ? "#707070" : "#ce0a2c";
            }
        });
  }
  window.addEventListener("DOMContentLoaded", updateCartCountBubble);
  // ================================
  // CL Sticky Header Logic
  // ================================
  document.addEventListener("DOMContentLoaded", function () {
    const header = document.querySelector(".clStickyHeader");
    const stickyATC = document.querySelector(".stickyAddToCart");
    const stickyFilter = document.querySelector("aside#main-collection-filters");
    const stickyDate = document.querySelector(".clDates");
    if (!header) return;
    let lastScroll = window.scrollY;
    const threshold = 100;
    let isSticky = false;
    function isDropdownActive() {
        return document.querySelector(
            ".cl-header--nav-bar-items.has-dropdown.active"
        );
    }
    // function updateStickyATCPosition() {
    //     if (!stickyATC && !stickyFilter && !stickyDate) return;
    //     const stickyTopValue = "65px";
    //     const isSticky = header.classList.contains("is-sticky");
    //     const newTop = isSticky ? stickyTopValue : "";
    //     if (stickyATC) stickyATC.style.top = newTop;
    //     if (stickyFilter) stickyFilter.style.top = newTop;
    //     if (stickyDate) stickyDate.style.top = newTop;
    //     const isStickyATCActive = stickyATC?.classList.contains("active");
    //     const isStickyFilterLifted = stickyFilter?.style.top === stickyTopValue;
    //     const isStickyDateLifted = stickyDate?.style.top === stickyTopValue;
    //     if (isStickyATCActive || isStickyFilterLifted || isStickyDateLifted) {
    //         header.style.boxShadow = "none";
    //     } else {
    //         header.style.boxShadow = "";
    //     }
    // }
    function setStickyState(active) {
        if (active === isSticky) return;
        isSticky = active;
        if (isSticky) {
            header.classList.add("is-sticky");
            document
                .querySelectorAll(".hide-on-sticky")
                .forEach((el) => el.classList.add("hidden"));
            document
                .querySelectorAll(".show-on-sticky")
                .forEach((el) => el.classList.remove("hidden"));
        } else {
            header.classList.remove("is-sticky");
            document
                .querySelectorAll(".hide-on-sticky")
                .forEach((el) => el.classList.remove("hidden"));
            document
                .querySelectorAll(".show-on-sticky")
                .forEach((el) => el.classList.add("hidden"));
        }
        updateStickyATCPosition();
    }
    function handleScroll() {
        const currentScroll = window.scrollY;
        if (window.innerWidth <= 768) {
            setStickyState(false);
            header.style.transform = "";
            return;
        }
        const dropdownActive = isDropdownActive();
        // Reset at top
        if (currentScroll === 0) {
            setStickyState(false);
            header.style.transform = "";
        } else if (dropdownActive) {
            // Megamenu is open - header must be sticky, use transform for show/hide
            setStickyState(true);
  
            if (currentScroll > lastScroll) {
                // Scrolling down when megamenu open - show header
                header.style.transform = "translateY(0)";
            } else if (currentScroll < lastScroll) {
                // Scrolling up when megamenu open - hide header to show megamenu clearly
                header.style.transform = "translateY(-100%)";
            }
        } else {
            // Megamenu is NOT open - manage is-sticky class normally
            if (currentScroll > lastScroll) {
                // Scrolling down - remove sticky class
                setStickyState(false);
                header.style.transform = "";
            } else if (currentScroll < lastScroll) {
                // Scrolling up - add sticky class (normal sticky header)
                setStickyState(true);
                header.style.transform = "";
            }
        }
        lastScroll = Math.max(0, currentScroll);
    }
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);
    const dropdownObserver = new MutationObserver(handleScroll);
    document
        .querySelectorAll(".cl-header--nav-bar-items.has-dropdown")
        .forEach((el) =>
            dropdownObserver.observe(el, {
                attributes: true,
                attributeFilter: ["class"],
            })
        );
    // Observe changes in stickyAddToCart active class
    if (stickyATC) {
        const atcObserver = new MutationObserver(updateStickyATCPosition);
        atcObserver.observe(stickyATC, {
            attributes: true,
            attributeFilter: ["class"],
        });
    }
  });
  // // ================================
  // // Mobile Sticky Header
  // // ================================
  document.addEventListener("DOMContentLoaded", function () {
    const header = document.querySelector(".cl-header--main-wrapper");
    let lastScrollY = window.scrollY;
  
    if (window.innerWidth <= 767 && header) {
        window.addEventListener("scroll", function () {
            const scrollY = window.scrollY;
            if (scrollY > 100) {
                header.classList.add("mb-sticky-header");
  
                if (scrollY < lastScrollY) {
                    // Scrolling up
                    header.classList.add("show");
                    header.classList.remove("hide");
                } else {
                    // Scrolling down
                    header.classList.add("hide");
                    header.classList.remove("show");
                }
            } else {
                // Reset everything near top
                header.classList.remove("mb-sticky-header", "show", "hide");
            }
            lastScrollY = scrollY;
        });
    }
  });
  const megaMenuWrapperContents = document.querySelectorAll('.cl-header--mega-menu-wrapper--content');
  megaMenuWrapperContents.forEach((megaMenuWrapperContent, index) => {
    const megaMenuItemsBtmWrapper = megaMenuWrapperContent.querySelector('.cl-header--mega-menu-items-btm-wrapper');
  
    if (megaMenuItemsBtmWrapper) {
        megaMenuWrapperContent.style.padding = '0';
    } else {
        megaMenuWrapperContent.style.padding = '0 0 50px';
    }
  });